const removeBlankLines = (value: string): string => {
  return value.replace(/^(?=\n)$|^\s*|\s*$|\n\n+/gm, "");
};

export default removeBlankLines;
